import React, { Component } from 'react';

class Voucher extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    const { voucher } =  this.props
    return (
    <div className="row">
        <div className="col">
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Voucher utilizado</h3>
                </div>
                <div className="card-body">
                  Código: {voucher.code}
                </div>
            </div>
        </div>
    </div>
    );
  }
}

export default Voucher;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Voucher/index.js